import * as types from '../constants/ActionTypes'


export default function patients(state = [], action) {
	switch (action.type) {
		case types.ADMIN_SAVE_PATIENT:
			return []

		case types.SET_PATIENTS:
			return action.payload;

		case types.INSERT_PATIENT:
			return [...state, action.payload];

		case types.REMOVE_PATIENT:
			return [
				...state.slice(0, action.payload),
				...state.slice(action.payload + 1)
			];

		case types.SET_PATIENT:
			return state.map((p) => {
				return p._id === action.payload._id ? action.payload : p
			});

		default:
			return state;
	}
}


/*
case types.ADD_ASSESSMENT:
	return state.map((p) => {
		return p._id === action.payload.patient ? {...p, assessments: [...p.assessments, action.payload]} : p
	});

case types.SET_ASSESSMENT:
	return state.map((p) => {
		return p._id === action.payload.patient ? {...p, assessments: action.payload }: p
	});
	*/



// WEBPACK FOOTER //
// ./src/reducers/patients.js